<template>
  <div class="inner-banner breadcrumb-area-info1 main-banner">
    <div class="image-layer" style="background-image: url(/assets/images/shape/shape-25.png);"></div>
    <div class="container">
      <div class="row">
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
          <div class="breadcrumb-content">
            <div class="section-title white-2">
              <h4>Service</h4>
              <h1 class="mt-3">サービス内容</h1>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <section class="auninfo_contact cantact_v2 section_padding margin-top-about breadcrumb-area-biz">
    <div class="container">
      <div class="block-title text-center" data-aos="fade-right" :data-aos-duration="500">
        <p><span>Service</span></p>
      </div>
      <div class="row mt-4">
        <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-12 container-wrap" v-for="item in sections" :key="item.section_key" data-aos="fade-right" :data-aos-duration="500">
          <div class="service-wrap service-wrap-agency overflow-hidden show service-card-link" @click="goDetail(item)">
            <h3>{{ item.title }}</h3>
            <p class="mt-4" style="white-space:pre-line">{{ item.body }}</p>
          </div>
        </div>
      </div>
      <br/><br/>
    </div>
  </section>
</template>

<script>
const defaults = [
  {section_key:'service_01', title:'国際医療サービス', body:'世界をリードする医療レベルの権威病院を合わせて、お客様に最適な専門家機関を適合させて、高品質な海外受診を享受する'},
  {section_key:'service_02', title:'日本での人材育成', body:'中国と日本の医学発展に貢献し、質の高い介護人材を養成し、各国の医学留学生の日本での就職を促進する'},
  {section_key:'service_03', title:'ハイエンドヘルスケアサービス', body:'プロアクティブでハイレベルの医療サービスでご健康を提供し、カスタマイズされたサービスなどを利用して、お客様に至れり尽くせりの標準化された親身的なサービス体験を提供する'}
];

export default {
  name: 'Service',
  data(){ return { sections: defaults } },
  mounted(){
    if (typeof $ !== 'undefined') {
      $.ajax({
        type:'GET',
        url:'/api/page_content.php?page=service&_=' + new Date().getTime(),
        dataType:'json',
        success:(res)=>{
          if(res && res.code===1 && res.list && res.list.length){ this.sections = res.list; }
        }
      });
    }
  },
  methods:{
    goDetail(item){
      const id = item.section_key || item.id || '';
      if(id){ this.$router.push('/serviceDetail/' + encodeURIComponent(id)); }
    }
  }
}
</script>

<style scoped>
.service-card-link { cursor: pointer; min-height: 230px; }
.service-card-link p { display: -webkit-box; -webkit-line-clamp: 5; -webkit-box-orient: vertical; overflow: hidden; }
</style>
